export default {
	timer_active: ' active',
	timer_active_title: 'Active Timers',
	timer_add_favorite: 'Add as favorite',
	timer_add_favorites_title: 'More Appointment Types',
	timer_appointment_rounding_label: 'Rounding',
	timer_appointment_title_label: 'Appointment title:',
	timer_appointment_type_label: 'Appointment type:',
	timer_btn_start: 'Start timer',
	timer_btn_stop_all: 'Stop all',
	timer_click_to_start: '→ Click to start',
	timer_dialog_title: 'Time tracking',
	timer_favorite_tooltip_click_to_start: 'Click to start',
	timer_favorites_title: 'Favorites',
	timer_manual_start: 'Start timer manually',
	timer_no_active_description: 'Start a new timer above',
	timer_no_active_title: 'No active timers',
	timer_no_favorites: 'You have no favorites configured',
	timer_open_appointment_details: 'Open appointment details',
	timer_quickstart_description: 'Recently used appointment types',
	timer_quickstart_no_recent_list: 'No recent timers yet',
	timer_remove_favorite: 'Remove favorite',
	timer_rename: 'Rename',
	timer_rounding_minutes_label: 'Rounding:',
	timer_select_appontmentType: 'Select appointment type',
	timer_select_no_options: 'No options available',
	timer_select_rounding_title: 'Select appointment rounding',
	timer_start: 'Start timer',
	timer_started: 'Started: ',
	timer_stop: 'Stop timer',
	timer_title: 'Start & manage timers',
	timer_tooltip_start: 'Start timer',
	timer_tooltip_stop: 'Stop timer',
};
